import { useState, useEffect } from 'react';
import {
  generateBooleanQuery,
  IBooleanQueryBuilderDTO,
  generateKeyWords,
  IJob,
} from 'wisestep-api';

export enum Mode {
  TALENT_POOL,
  NATIVE,
}
const jobBoardDetails = new Map<string, string>();
jobBoardDetails.set('DICE_SEARCH', 'dice');
jobBoardDetails.set('TECH_FETCH', 'techFetch');
jobBoardDetails.set('CAREER_BUILDER', 'careerBuilder');

const useKeyWordGenerator = (mode: Mode, job?: IJob, jobBoardName?: string) => {
  const [searchKeywordQuery, setSearchKeyWordQuery] = useState<string>('');

  useEffect(() => {
    const getGeneratedBooleanQuery = async () => {
      if (job) {
        try {
          if (mode == Mode.TALENT_POOL) {
            const query: IBooleanQueryBuilderDTO = {
              mode: 'quick',
              jobTitle: job.title,
              requiredSkills: job.skills,
              jobDescription: job.description,
              jobId: job.id,
              queryTypes: { open: true, focused: true, comprehensive: true },
              queryResponse: { open: 'true', focused: 'true', comprehensive: 'true' },
            };
            const queryResponse = await generateBooleanQuery(query);
            setSearchKeyWordQuery(queryResponse.data.booleanQuery.focused);
          } else {
            const jobBoard = jobBoardDetails.has(jobBoardName ?? '');
            if (jobBoard) {
              const query: IBooleanQueryBuilderDTO = {
                jobDescription: job.description
                  ?.replace(/<[^>]+>/g, '')
                  .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, ''),
                jobTitle: job.title,
              };
              const queryResponse = await generateKeyWords(query);
              setSearchKeyWordQuery(
                queryResponse.data.results[jobBoardDetails.get(jobBoardName ?? '') ?? '']
              );
            } else {
              setSearchKeyWordQuery('');
            }
          }
        } catch (error) {
          setSearchKeyWordQuery('');
        }
      }
    };
    getGeneratedBooleanQuery();
  }, [job, jobBoardName, mode]);
  return searchKeywordQuery;
};
export default useKeyWordGenerator;
